.legend {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 1em;

  @media print {
    max-width: 30%;
  }
}

.legendItem {
  flex-grow: 1;
  display: flex;
  align-items: center;
  margin-right: 1em;

  p {
    font-size: 1em;
    margin-bottom: 0;
  }
}

.legendValue {
  font-size: 1.5em;
  font-weight: bold;
}

.legendDescription {
  flex: 1 1 100%;
  margin-left: 1em;
  padding-left: 0.5em;
  font-size: 0.6em;
  text-transform: uppercase;
  height: 2em;
  line-height: 2;
}

.legendDescriptionUser {
  border-left: 2px solid var(--orange);
}

.legendDescriptionGroup {
  border-left: 2px solid var(--red);
}

.minMax {
  position: relative;
  top: -5px;
}

.minMaxValue {
  margin-right: 0.5em;
  white-space: nowrap;

  p {
    line-height: 0;
  }
}

.text {
  margin-bottom: 1em;
}
